import Vue from 'vue';
import VueInfiniteLoading from 'vue-infinite-loading';
import LoadingSpinner from '@/components/_common/LoadingSpinner.vue';

const config = {
	props: {
		spinner: 'waveDots',
	},
	slots: {
		spinner: LoadingSpinner,
	},
};
Vue.use(VueInfiniteLoading, config);
